module.exports = __webpack_public_path__ + "img/lan.20741abb.png";